/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChargeIdEnum } from './chargeIdEnum';
import { LimitsWarning } from './limitsWarning';


export interface DeploymentLimits { 
    charge_id?: ChargeIdEnum;
    current_subscription_quantity?: number;
    current_usage?: number;
    enabled?: boolean;
    metering_min_quantity?: number;
    recommended_subscription_quantity?: number;
    warning?: Array<LimitsWarning>;
}
export namespace DeploymentLimits {
}


